import { makeStyles } from '@material-ui/core';
import OxqLogo from './logo/oxq-logo.svg';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
  },
  path: {
    fill: '#7df3e1',
  },
});
const LogoFull = () => {
  const classes = useStyles();

  return (
    <img
      src={OxqLogo}
      alt="Oxq Logo"
      className={classes.svg}
      // style={{ filter: 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.5))' }}
      data-testid="logo-full"
    />
  );
};

export default LogoFull;
